import React, { useContext, useEffect, useRef, useState } from "react";
import SelectControl from "../../components/SelecControl/SelectControl";

import {Html5QrcodeScanner} from 'html5-qrcode';

import activosContext from '../../context/activoContex/activoContex.js';
import authContext from "../../context/authentication/authContex.js";
import Stopwatch from "../../components/stopwatch/Stopwatch.js";
import ModalForm from "../../components/modalForm/ModalForm.js";
import moment from "moment";
import FormConsumo from "../../components/formConsumo/FormConsumo.js";
import { estructuraOrdenTrabajo } from "../../utils/estructuras.js";
import checklistContext from "../../context/checklistContext/checklistContext.js";
import QRCode from 'react-qr-code';

import './AppMobile.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";

const AppMobile = ({}) =>{

    const [activoSelected,setActivoSelected] = useState(null);
    const [scaned,setScaned] = useState(null);
    const [isRunning,setIsRunning] = useState(false);
    const [startDate,setStartDate] = useState(null);
    const [checklistSaved,setChecklistSaved] = useState(null);
    const scannerRef = useRef(null);

    const { usuario } = useContext(authContext);

    const [discoverLinks, setDiscoverLinks] = useState({ appAndroid: null, appIOS: null });

    useEffect(() => {
        if (!usuario?.tenantId) return;
        const fetchDiscoverLinks = async () => {
            try {
                const [androidResp, iosResp] = await Promise.all([
                    fetch(`https://discover.xertux.com/api/tenant/discoverPlatform/${usuario.tenantId}/XMANT_ANDROID`, {
                        headers: { 'x-api-key': 'xertux_discover_api_key_2024' }
                    }),
                    fetch(`https://discover.xertux.com/api/tenant/discoverPlatform/${usuario.tenantId}/XMANT_IOS`, {
                        headers: { 'x-api-key': 'xertux_discover_api_key_2024' }
                    })
                ]);
                const androidData = await androidResp.json();
                const iosData = await iosResp.json();
                setDiscoverLinks({
                    appAndroid: androidData?.data?.link || null,
                    appIOS: iosData?.data?.link || null
                });
            } catch (error) {
                console.log("Error fetching discover links:", error);
            }
        };
        fetchDiscoverLinks();
    }, [usuario?.tenantId]);

    useEffect(()=>{
        Swal.fire('Aguarde', "En cuanto los QRs se muestren en pantalla escanee el asociado a su sistema operativo para ser redirigido a la pagina de la aplicacion")
    },[])

    return <div className="appMobileView">
        {(discoverLinks.appAndroid || discoverLinks.appIOS) && <div className='divQRs'>
            <div className='containerQRs'>
                {discoverLinks.appAndroid && <div className='qrLinkAppDiv'>
                    <div className="header">
                        <img style={{width:50, height:50}} src="/android-brands-solid.svg"/>
                        <h4>Android</h4>
                    </div>
                    <QRCode style={{width:350, height:350}} value={discoverLinks.appAndroid}/>
                </div>}
                {discoverLinks.appIOS && <div className='qrLinkAppDiv'>
                    <div className="header">
                        <img style={{width:50, height:50}} src="/apple-brands-solid.svg"/>
                        <h4>iOS</h4>
                    </div>
                    <QRCode style={{width:350, height:350}} value={discoverLinks.appIOS}/>
                </div>}
            </div>
        </div>}
    </div>

}

export default AppMobile;